<template>
  <DDT/>
</template>

<script>
import DDT from '@/components/MAGAZZINO/DDT.vue';

export default {
  name: 'DDTVIEW',
  components: {
    DDT,
  },
}
</script>